// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useRef, useState } from 'react';
import { MDBTooltip } from 'mdbreact';
import AmountInfo from './AmountInfo';
import { localCurrencySettings } from '../../../../../utils/constans';
import '../../../../../sass/custom_styles/ellipsis_with_tooltip.scss'

const ApplyInfoRow = ({
  applyInfo,
  selectedApplies = [],
  handlerInputChanges,
  current = false,
}) => {
  const rowColor = current ? 'row-current' : 'row-default';

  return (
    <tr className={`apply-row ${rowColor}`}>
      {/* WIN */}
      <td className="table-cell win-cell">
        {current ? (
          <label className={`checkbox-wrapper check_btn ${current ? 'checkbox-current' : ''}`} style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              name={applyInfo.workOrderId}
              checked={current || selectedApplies.includes(applyInfo.workOrderId)}
              disabled={current}
              onChange={current ? undefined : handlerInputChanges}
            />
            <span className="checkbox-label">{applyInfo.WIN}</span>
          </label>
        ) : (
          <label className="checkbox-wrapper check_btn" style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              name={applyInfo.workOrderId}
              checked={selectedApplies.includes(applyInfo.workOrderId)}
              onChange={handlerInputChanges}
            />
            <span className="checkbox-label">{applyInfo.WIN}</span>
          </label>
        )}
      </td>

      {/* WO ID */}
      <td className="table-cell">
        <EllipsisWithTooltip text={applyInfo.customTagId} />
      </td>

      {/* TITLE */}
      <td className="table-cell">
        <EllipsisWithTooltip text={applyInfo.title} />
      </td>

      {/* TRAVEL EXPENSE */}
      <td className={`table-cell ${current ? 'color-current' : 'color-warning'}`}>
        {applyInfo.bidAmountExpense && (
          <EllipsisWithTooltip
            text={`${applyInfo.bidAmountExpense.toLocaleString(
              'en-US',
              localCurrencySettings,
            )} - ${applyInfo.bidDescriptionExpense}`}
          />
        )}
      </td>

      {/* START DATE */}
      <td className="table-cell">
        <StartDate
          startDate={applyInfo.startDate}
          bidStartDate={applyInfo.bidStartDate}
          current={current}
        />
      </td>

      {/* ADDRESS */}
      <td className="table-cell">
        <EllipsisWithTooltip
          text={
            applyInfo?.city && applyInfo?.state
              ? `${applyInfo.city}, ${applyInfo.state}`
              : applyInfo?.city
                ? applyInfo.city
                : applyInfo?.state
                  ? applyInfo.state
                  : '-'
          }
        />
      </td>

      {/* PRICE */}
      <td className="table-cell">
        <AmountInfo
          current={current}
          bidBasicType={applyInfo.bidBasicType}
          amountBase={+applyInfo.amountBase}
          amountVariable={+applyInfo.amountVariable}
          basicWorkType={applyInfo.basicWorkType}
          variableWorkType={applyInfo.variableWorkType}
          bidAmountBase={+applyInfo.bidAmountBase}
          bidAmountVariable={+applyInfo.bidAmountVariable}
        />
      </td>
    </tr>
  );
};

export default ApplyInfoRow;

const EllipsisWithTooltip = ({ text }) => {
  const spanRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const el = spanRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  if (!text) return <span>-</span>;

  return (
    <div className="white-tooltip-title">
      {isTruncated ? (
        <MDBTooltip domElement placement="top">
          <div className="ellipsis tooltip-cell" ref={spanRef}>
            {text}
          </div>
          <div className="amount-tooltip-title tooltip-content">{text}</div>
        </MDBTooltip>
      ) : (
        <div className="ellipsis tooltip-cell" ref={spanRef}>
          {text}
        </div>
      )}
    </div>
  );
};

const StartDate = ({ startDate, bidStartDate, current }) => {
  const isBidDate = bidStartDate && bidStartDate !== startDate;

  const colorClass = current
    ? 'color-current'
    : isBidDate
      ? 'color-warning'
      : 'color-default';

  const date = isBidDate ? bidStartDate : startDate;

  return (
    <div className={colorClass}>
      {new Date(date).toLocaleString('en-US', { timeZone: 'UTC' })}
    </div>
  );
};